"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookItem_1 = require("../CodebookItem");

var CodebookItemConverter_1 = require("./CodebookItemConverter");
/**
 * Default implementation of CodebookItemConverter.
 *
 * @author Radek Beran
 */


var CodebookItemConverterImpl =
/*#__PURE__*/
function (_CodebookItemConverte) {
  _inherits(CodebookItemConverterImpl, _CodebookItemConverte);

  function CodebookItemConverterImpl() {
    _classCallCheck(this, CodebookItemConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodebookItemConverterImpl).apply(this, arguments));
  }

  _createClass(CodebookItemConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CodebookItem_1.CodebookItem(CodebookItem_1.CodebookItem.schema.id.valueOf(conversions.documentToClassId(source)), CodebookItem_1.CodebookItem.schema.title.valueOfField(source), CodebookItem_1.CodebookItem.schema.description.valueOfField(source), CodebookItem_1.CodebookItem.schema.flags.valueOfField(source), CodebookItem_1.CodebookItem.schema.externalId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        title: source.title,
        description: source.description,
        flags: conversions.asObjectArray(source, 'flags', function (flag) {
          return flag;
        }),
        externalId: source.externalId
      });
      return document;
    }
  }]);

  return CodebookItemConverterImpl;
}(CodebookItemConverter_1.CodebookItemConverter);

exports.CodebookItemConverterImpl = CodebookItemConverterImpl;